import React from 'react';
import { Card, message } from 'antd';
import { ApiUsersGetResponse } from '../../services/api/types/users';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { selectUserState } from '../../store/selectors/user';
import { apiUsersGet } from '../../services/api/users';
import { RouterPaths } from '../../router/paths';
import FeatureUsageEditTable from '../../components/FeatureUsageEditTable';

function UserUsagePage() {
  const navigate = useNavigate();
  const { userId } = useParams();
  const { token } = useSelector(selectUserState);
  const [loadedUser, setLoadedUser] =
    React.useState<ApiUsersGetResponse | null>(null);

  async function loadUser(tk: string, uid: number) {
    const [response, status] = await apiUsersGet(uid, tk);
    if (status === 200 && response) {
      setLoadedUser(response);
    } else {
      message.error({ content: 'User not found!' });
      navigate(RouterPaths.USERS);
    }
  }

  React.useEffect(() => {
    if (userId && token) {
      loadUser(token, parseInt(userId, 10));
    }
  }, [userId, token]);

  if (!userId) {
    navigate(RouterPaths.USERS);
    return null;
  }

  return (
    <Card bordered={false} title="User Usage" loading={!loadedUser?.id}>
      {!loadedUser ? null : (
        <FeatureUsageEditTable userId={loadedUser.aliasId} />
      )}
    </Card>
  );
}

export default UserUsagePage;
